import { createAction } from 'redux-actions';
import I18n from 'I18n';
import getApplicationName from 'ui-forms-editor-automation-lib/selectors/parentApplication/getApplicationName';
import getGuid from 'ui-forms-editor-automation-lib/selectors/getGuid';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
import SOURCE_APP from 'ui-forms-editor-automation-lib/constants/SOURCE_APP';
import postAddNewWorkflow from 'ui-forms-editor-automation-lib/api/postAddNewWorkflow';
import createErrorAction from 'ui-forms-editor-automation-lib/utils/createErrorAction';
import { updateFlowUsagesAction } from 'ui-forms-editor-automation-lib/actions/updateFlowUsages';
import getFlowUsages from 'ui-forms-editor-automation-lib/selectors/flowUsages/getFlowUsages';
export const REQUEST_CREATE_A_NEW_WORKFLOW = '@@lib/REQUEST_CREATE_A_NEW_WORKFLOW';
export const SUCCESS_CREATING_A_NEW_WORKFLOW = '@@lib/SUCCESS_CREATING_A_NEW_WORKFLOW';
export const FAIL_CREATING_A_NEW_WORKFLOW = '@@lib/FAIL_CREATING_A_NEW_WORKFLOW';
const requestCreateANewWorkflow = createAction(REQUEST_CREATE_A_NEW_WORKFLOW);
const successCreatingANewWorkflow = createAction(SUCCESS_CREATING_A_NEW_WORKFLOW, payload => payload, () => ({
  notification: {
    type: 'info',
    message: I18n.text('automationLib.createYourOwnSection.workflowCreated')
  }
}));
const failCreatingANewWorkflow = createErrorAction(FAIL_CREATING_A_NEW_WORKFLOW, 'automationLib.errorMessages.failCreatingNewWorkflow');
const createNewWorkflow = ( /*workflowTrigger: any*/
) => (dispatch, getState) => {
  const state = getState();
  const flowUsages = getFlowUsages(state);
  const applicationName = getApplicationName(state);
  const guid = getGuid(state);
  dispatch(requestCreateANewWorkflow());
  let sourceApp;
  switch (applicationName) {
    case APPLICATION_NAMES.LEADFLOWSUI:
      sourceApp = SOURCE_APP.LEAD_FLOWS_APP;
      break;
    case APPLICATION_NAMES.FORMSUI:
    default:
      sourceApp = SOURCE_APP.FORMS_APP;
      break;
  }
  return postAddNewWorkflow(guid, sourceApp /*workflowTrigger*/).then(payload => {
    const updatedFlowUsages = [...flowUsages, {
      id: payload.flowId,
      isExternalLink: false
    }];
    dispatch(updateFlowUsagesAction(updatedFlowUsages));
    dispatch(successCreatingANewWorkflow(payload));
  }).catch(error => {
    dispatch(failCreatingANewWorkflow(error));
  });
};
export default createNewWorkflow;